import { render, staticRenderFns } from "./StudentCardMoreButton.vue?vue&type=template&id=f4cc52d6"
import script from "./StudentCardMoreButton.vue?vue&type=script&lang=js"
export * from "./StudentCardMoreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports